const t = "_pageHeaderWrapper_2zt3h_1", a = "_pageHeaderContainer_2zt3h_5", e = "_buttonClass_2zt3h_9", n = "_dropDownBtn_2zt3h_16", r = "_avatarEditContainer_2zt3h_20", o = "_avatarEdit_2zt3h_20", _ = "_iconSubtitle_2zt3h_43", i = {
  pageHeaderWrapper: t,
  pageHeaderContainer: a,
  buttonClass: e,
  dropDownBtn: n,
  avatarEditContainer: r,
  avatarEdit: o,
  iconSubtitle: _
};
export {
  o as avatarEdit,
  r as avatarEditContainer,
  e as buttonClass,
  i as default,
  n as dropDownBtn,
  _ as iconSubtitle,
  a as pageHeaderContainer,
  t as pageHeaderWrapper
};
//# sourceMappingURL=PageHeader.module.scss.js.map
